import { createSlice } from "@reduxjs/toolkit";

// Cross-component "do this now" signal — lets ChatActionBox.jsx (deep inside
// the composer, TextBox.jsx) trigger UI that only exists as local state in a
// sibling component (ChatboxNavbar.jsx's Assign dropdown / Close-conversation
// action), without prop-drilling through ChatBox.jsx/Inbox.jsx. The consuming
// component reacts to `request` changing (via its nonce, so the same type can
// fire twice in a row) then calls clearComposerActionRequest() once handled.
//
// Rahim, 2026-08-24: "Assign" and "Close conversation" in the Search Actions
// popup (ChatActionBox.jsx) were calling setOpenDialog("assign")/("close") —
// dead state nothing ever listened for. The real Assign/Close UI already
// exists in ChatboxNavbar.jsx as local component state; this slice bridges
// the two instead of building a second, duplicate Assign/Close flow.
const composerActionsSlice = createSlice({
  name: "composerActions",
  initialState: {
    // { type: "assign" | "close", nonce: number } | null
    request: null,
  },
  reducers: {
    requestComposerAction: (state, action) => {
      state.request = { type: action.payload, nonce: Date.now() + Math.random() };
    },
    clearComposerActionRequest: (state) => {
      state.request = null;
    },
  },
});

export const { requestComposerAction, clearComposerActionRequest } = composerActionsSlice.actions;
export default composerActionsSlice.reducer;
